import { render, staticRenderFns } from "./TabelaValorHoraHomem.vue?vue&type=template&id=ead1f9dc&"
import script from "./TabelaValorHoraHomem.vue?vue&type=script&lang=js&"
export * from "./TabelaValorHoraHomem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
